<template>
  <header class="nav">
    <div class="nav__inner">
      <router-link to="/" class="nav__brand" @click="close">
        <img :src="logo" alt="Tokyo Rights Service" class="nav__logo">
      </router-link>

      <button
        class="nav__toggle"
        type="button"
        aria-label="メニュー"
        aria-controls="nav-menu"
        :aria-expanded="open ? 'true' : 'false'"
        @click="open = !open"
      >
        <i :class="open ? 'fas fa-times' : 'fas fa-bars'" aria-hidden="true"></i>
      </button>

      <nav id="nav-menu" class="nav__menu" :class="{ 'nav__menu--open': open }">
        <router-link
          v-for="item in links"
          :key="item.hash"
          :to="{ path: '/', hash: item.hash }"
          class="nav__link"
          @click="close"
        >{{ item.label }}</router-link>
        <router-link to="/inquiry" class="nav__cta" @click="close">お問い合わせ</router-link>
      </nav>
    </div>
  </header>
</template>

<script>
import { ref } from 'vue'
import logo from '../assets/logo.png'

export default {
  setup () {
    const open = ref(false)
    const close = () => { open.value = false }
    const links = [
      { hash: '#about', label: '私たちについて' },
      { hash: '#business', label: '事業' },
      { hash: '#news', label: 'お知らせ' },
      { hash: '#releases', label: 'リリース' },
      { hash: '#company', label: '会社概要' },
      { hash: '#recruit', label: '採用' }
    ]
    return { logo, open, close, links }
  }
}
</script>

<style scoped>
.nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 50;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid var(--line);
}

.nav__inner {
  max-width: 1040px;
  margin: 0 auto;
  height: 60px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.nav__logo {
  height: 26px;
  display: block;
}

.nav__toggle {
  display: none;
  background: none;
  border: none;
  font-size: 20px;
  color: var(--ink);
  cursor: pointer;
}

.nav__menu {
  display: flex;
  align-items: center;
  gap: 22px;
}

.nav__link {
  font-size: 13px;
  font-weight: 500;
  color: var(--ink-soft);
  text-decoration: none;
  transition: color 0.15s;
}

.nav__link:hover {
  color: var(--brand-pink);
}

.nav__cta {
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  background: var(--brand-pink);
  text-decoration: none;
  padding: 8px 18px;
  border-radius: var(--radius-pill);
  transition: transform 0.15s, opacity 0.15s;
}

.nav__cta:hover {
  transform: translateY(-1px);
  opacity: 0.92;
}

@media (max-width: 768px) {
  .nav__toggle {
    display: block;
  }

  .nav__menu {
    position: absolute;
    top: 60px;
    left: 0;
    right: 0;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    background: rgba(255, 255, 255, 0.98);
    border-bottom: 1px solid var(--line);
    padding: 12px 20px 20px;
    display: none;
  }

  .nav__menu--open {
    display: flex;
  }

  .nav__link {
    padding: 8px 0;
    font-size: 15px;
  }

  .nav__cta {
    margin-top: 8px;
  }
}
</style>
